<template>
  <FormGroup
    :helpText="helpText"
    :id="id"
    :invalidFeedback="invalidFeedback"
    :label="label"
    :required="required"
    :validFeedback="validFeedback"
  >
    <template v-if="$slots.label" #label>
      <slot name="label"></slot>
    </template>
    <template v-if="$slots.prefix" #prefix>
      <slot name="prefix"></slot>
    </template>

    <component
      v-bind="$attrs"
      class="form-control"
      :class="{ 'is-valid': validFeedback, 'is-invalid': invalidFeedback }"
      :id="id"
      :is="tag"
      :prefix="prefix"
      :required="required"
    >
      <slot></slot>
    </component>
  </FormGroup>
</template>

<script lang="ts">
export type InputFieldProps = FormGroupProps & {
  tag?: string | ComponentPublicInstance;
};
</script>

<script lang="ts" setup>
import { uniqueId } from "underscore";
import { ComponentPublicInstance } from "vue";
import FormGroup, { FormGroupProps } from "./FormGroup.vue";

withDefaults(defineProps<InputFieldProps>(), {
  id: uniqueId("field-"),
  tag: "input",
});
</script>
